import ReportsLayout
  from '../components/ReportsLayout'
import CuratorsList
  from '../components/CuratorList'
import TherapistList
  from '../components/TherapistList'
import ClientsList
  from '../components/ClientsList'
import ArchiveList
  from '../components/ArchiveList'
import canViewReports
  from '../../../router/hooks/canViewReports';


export default [
  {
    path: '/reports',
    component: ReportsLayout,
    children: [
      {
        path: 'curators',
        name: 'curator-reports',
        component: CuratorsList,
        props: true,
        beforeEnter: canViewReports,
      },
      {
        path: 'therapists',
        name: 'therapist-reports',
        component: TherapistList,
        props: true,
        beforeEnter: canViewReports,
      },
      {
        path: 'clients',
        name: 'client-reports',
        component: ClientsList,
        props: true,
        beforeEnter: canViewReports,
      },
      {
        path: 'archive',
        name: 'archive-reports',
        component: ArchiveList,
        beforeEnter: canViewReports,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/modules/reports/routes/index.js